import React from 'react';
import { Calendar as CalendarIcon, Clock, Users, Briefcase } from 'lucide-react';
import InfoBanner from '../../components/ui/info-banner';

const CalendarPage = () => {
  return (
    <div className="space-y-6" data-testid="calendar-page">
      {/* Bilgilendirme Notu */}
      <InfoBanner id="portal-calendar-info" variant="info">
        <strong>Takvim:</strong> Takvimi kullanarak ajandanıza yeni notlar ekleyebilir, hatırlatıcı kurabilir ve bu notlara istediğiniz kişileri ekleyebilirsiniz. 
        <strong>Hatırlatıcı ekle</strong> ile daha karmaşık zaman aralıklarında hatırlatmalar yapabilirsiniz. 
        <strong>Hatırlatıcı listesinden</strong> bu hatırlatmalara ulaşabilirsiniz. 
        Sadece kendi oluşturduğunuz notları silebilirsiniz.
      </InfoBanner>

      {/* Header */}
      <div>
        <h2 className="text-3xl font-bold tracking-tight">Takvim</h2>
        <p className="text-[hsl(var(--muted-foreground))]">İzinleriniz, mesaileriniz ve şirket etkinlikleri</p>
      </div>

      {/* Calendar Placeholder */}
      <div className="bg-white rounded-lg border border-[hsl(var(--border))] p-8 h-[600px] flex items-center justify-center">
        <div className="text-center max-w-md">
          <CalendarIcon className="h-24 w-24 mx-auto mb-4 text-[hsl(var(--brand-700))] opacity-20" />
          <h3 className="text-2xl font-bold mb-2">Takvim Sistemi</h3>
          <p className="text-[hsl(var(--muted-foreground))] mb-6">
            Kişisel ve şirket takvimi yakında aktif olacak!
          </p>
          
          <div className="grid grid-cols-2 gap-4 text-left">
            <div className="bg-green-50 p-4 rounded-md border border-green-200">
              <div className="flex items-center gap-2 mb-2">
                <CalendarIcon className="h-5 w-5 text-green-600" />
                <span className="font-semibold text-green-900">İzinler</span>
              </div>
              <p className="text-sm text-green-700">Onaylı izinleriniz</p>
            </div>
            
            <div className="bg-blue-50 p-4 rounded-md border border-blue-200">
              <div className="flex items-center gap-2 mb-2">
                <Clock className="h-5 w-5 text-blue-600" />
                <span className="font-semibold text-blue-900">Mesailer</span>
              </div>
              <p className="text-sm text-blue-700">Vardiya programınız</p>
            </div>
            
            <div className="bg-purple-50 p-4 rounded-md border border-purple-200">
              <div className="flex items-center gap-2 mb-2">
                <Users className="h-5 w-5 text-purple-600" />
                <span className="font-semibold text-purple-900">Etkinlikler</span>
              </div>
              <p className="text-sm text-purple-700">Şirket etkinlikleri</p>
            </div>
            
            <div className="bg-orange-50 p-4 rounded-md border border-orange-200">
              <div className="flex items-center gap-2 mb-2">
                <Briefcase className="h-5 w-5 text-orange-600" />
                <span className="font-semibold text-orange-900">Tatiller</span>
              </div>
              <p className="text-sm text-orange-700">Resmi tatiller</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarPage;
